<div class="card">
  <div class="card-header">
    <div class="row align-items-center flex-nowrap">
      <div class="col">
        <div class="row g-2 flex-nowrap">
          <div class="col-auto">
            <div class="card-icon">
              <i class="bx bxs-news"></i>
            </div>
          </div>
          <div class="col">
            <h4 class="m-0">Announcements</h4>
            <p class="m-0" *ngIf="unreadCount$ | async as unreadCount">{{ unreadCount }} Unread</p>
          </div>
        </div>
      </div>
      <div class="col text-end lh-1">
        <a [routerLink]="['announcements']" class="text-icon float-end">
          Go to announcements
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="card-body pb-0">
    <div class="card card-light" *ngFor="let item of collection$ | async | slice: 0 : 1">
      <a class="card-body" href="javascript: void(0);" (click)="onDetails(item)">
        <div class="row g-3">
          <div class="col-auto" *ngIf="item.media">
            <div [style.width]="'60px'">
              <div class="gallery-image">
                <img [src]="item.media.url" alt="..." class="img-fluid rounded-circle" />
              </div>
            </div>
          </div>
          <div class="col">
            <div class="row mb-1">
              <div class="col">
                <span class="badge bg-danger" *ngIf="!item.isReadInd">Unread</span>
                <span class="badge bg-success" *ngIf="item.isReadInd">Read</span>
              </div>
            </div>
            <div class="row g-2">
              <div class="col">
                <h5 class="text-primary fw-bolder m-0">
                  {{ item.title }}
                </h5>
                <p class="col paragraph-truncate lines-2 m-0">
                  {{ item.text }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
